import { useEffect, useState } from 'react';
import { changesApi } from '../../../services/changesApi';

export function useIncidentFirstContactGroups(workflowId: number | '' | undefined) {
  const [groups, setGroups] = useState<Array<{ id: number; name: string }>>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!workflowId) {
      setGroups([]);
      setLoading(false);
      return undefined;
    }
    let cancelled = false;
    setLoading(true);
    void changesApi
      .listIncidentFirstContactGroups(Number(workflowId))
      .then((items) => {
        if (!cancelled) setGroups(items);
      })
      .catch(() => {
        if (!cancelled) setGroups([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [workflowId]);

  return { groups, loading };
}
